import {TPMEventBO} from "./TPMEventBO";
import * as _ from 'lodash'
import {
  PaymentMethod_OffInvoice,
  Product_RowType_Consumer,
  Product_RowType_Display,
  Product_RowType_Finished
} from "../PA.TPM.Core/TPM.Constants";
import {TPMEventSpend} from "./TPMEventBO.ITPMEventSpend";
import {WB_FinishedProductRow, WB_ProductGroupRow} from "../PA.Core/PAdbSchemaRows";
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";
import {Message_restate} from "../PA.Core/Basic/MessageUtils";
import {DateUtils} from "../PA.Core/Basic/Dates";
import {SpendHistory_getBySpend} from "./TPMEventSpendHistory";
import {esWB_Finished_Product, esWB_Product_Group} from "../PA.Core/PAdbSchema";
import {NumberUtils} from "../PA.Core/Basic/Numbers";


export class TPMEventOffInvoiceUtils {


  static async validateOffInvoiceChanges(aSpend: TPMEventSpend): Promise<void> {

      if (!aSpend.isActive)
        return

      if (!aSpend.bIsLoaded)
        return

      if (aSpend.TPMEventSpendRow.cif.PAYMENT_METHOD != PaymentMethod_OffInvoice)
        return

      TPMEventOffInvoiceUtils.Spend_validateOffInvoiceProducts(<any>aSpend)

      await TPMEventOffInvoiceUtils.Spend_resetOESSpendInd(<any>aSpend)

  }


  static Spend_validateOffInvoiceProducts(aSpend: TPMEventSpend): void {
    let bo = aSpend.TPMEventBO

    let includedProductCount = 0
    let includedConsumerProductCount = 0
    let includedFinishedProductCount = 0
    let includedDisplayProductCount = 0
    let arrProductsWithCasePackZero: WB_FinishedProductRow[] = []
    let uid = aSpend.TPMEventSpendRow.cif.EVENT_SPEND_ID

    _.forEach(aSpend.TPMEventSpendRow.WB_TPM_EventSpendPrdRows, (aRow) => {
      if (!aRow.isActive) {
        return
      }
      if ((aRow.cif.INCLUDE_IND == '1') && (aRow.WB_ProductRow)) {

        let aProduct = aRow.WB_ProductRow

        includedProductCount += 1

        switch (aRow.cif.ROW_TYPE) {
          case Product_RowType_Consumer:
            includedConsumerProductCount += 1
            break;

          case Product_RowType_Finished:
            includedFinishedProductCount += 1
            if (aProduct.cif.CASE_PACK_SIZE <= 0) {
              arrProductsWithCasePackZero.push(aProduct)
            }
            break;

          case Product_RowType_Display:
            includedDisplayProductCount += 1
            break;
        }

      }

    })

    if (!_.isEmpty(arrProductsWithCasePackZero)) {
      let sZeroCasePacks = _.join(_.map(arrProductsWithCasePackZero, (aPrd) => aPrd.cif.PRODUCT_ID), ',')
      let sZeroCasePackDesc = _.join(_.map(arrProductsWithCasePackZero, (aPrd) => aPrd.cif.PRODUCT_NAME + ' (' + aPrd.cif.PRODUCT_ID + ')'), ',\n\r')

      let aMessageType = MessageType.Warning
      if (bo.PrimaryWorkflowProcessor.NextState.StatusTypeApproved || aSpend.PrimaryWorkflowProcessor.NextState.StatusTypeApproved) {
        aMessageType = MessageType.Error
      }
      Message_restate(aSpend.ValidateMessageProvider, true, `${uid}-OICasePack`,
        {Title: `Products with case pack zero, (${sZeroCasePacks})`, Desc: sZeroCasePackDesc}, aMessageType)
    }


  }

  static async Spend_resetOESSpendInd(aSpend: TPMEventSpend) {
    let spnd = aSpend.TPMEventSpendRow
    let bo = aSpend.TPMEventBO
    let dbContext = bo.dbContext
    let wfLogCode = `OI-${spnd.cif.EVENT_SPEND_ID}`
    bo.PrimaryWorkflowProcessor.removeStatusHistoryLogMessage(wfLogCode)

    let initSpend = aSpend.TPMEventBO.SpendInitialState[spnd.cif.WB_TEVTS_ID]
    if (!initSpend) {
      return
    } // New Spend
    let currSpend = SpendHistory_getBySpend(aSpend)

    // Check for Changes
    // 1. Shipment Dates
    // 2. Rates
    // 3. Included Products
    let spendChanges: string[] = []

    // 1. Shipment Dates
    if (!(DateUtils.isEqual(initSpend.Shipment_Start_Dt, spnd.ShipmentStartDt) && DateUtils.isEqual(initSpend.Shipment_End_Dt, spnd.ShipmentEndDt))) {
      //Change
      let initRange = DateUtils.formatRange({StartDt: initSpend.Shipment_Start_Dt, EndDt: initSpend.Shipment_End_Dt})
      let newRange = DateUtils.formatRange({StartDt: spnd.ShipmentStartDt, EndDt: spnd.ShipmentEndDt})
      spendChanges.push(`Shipment Dates changed from ${initRange} to ${newRange}.`)
    }

    // 2. Rates
    let rateLevel = aSpend.TPMEventSpendRow.WB_TPM_EventSpendTypeRow.cif.RATE_LEVEL
    switch (rateLevel) {
      case "Header":
        if (initSpend.Rate_Amt != currSpend.Rate_Amt) {
          spendChanges.push(`Rate changed from ${NumberUtils.formatMoney(initSpend.Rate_Amt)} to ${NumberUtils.formatMoney(currSpend.Rate_Amt)}.`)
        }
        break;

      case "ProductGroup":
        let pgIds = _.union(_.keys(initSpend.ProductGroupProperties), _.keys(currSpend.ProductGroupProperties))
        let dctPrdGrp = _.keyBy(<WB_ProductGroupRow[]>await dbContext.findUsingCache(esWB_Product_Group, pgIds), (aRow) => aRow.cif.WB_PRDGRP_ID)
        _.forEach(pgIds, (anId: number, key: any) => {
          let aPrdGrp = dctPrdGrp[anId]
          if (!aPrdGrp) {
            return
          }
          let initRate = 0
          let currRate = 0
          if (anId in initSpend.ProductGroupProperties) {
            initRate = initSpend.ProductGroupProperties[anId].Rate_Amt
          }
          if (anId in currSpend.ProductGroupProperties) {
            currRate = currSpend.ProductGroupProperties[anId].Rate_Amt
          }

          if (currRate != initRate) {
            spendChanges.push(`${aPrdGrp.cif.PRODUCT_GROUP_NAME} (${aPrdGrp.cif.PRODUCT_GROUP_ID}) rate changed from ${NumberUtils.formatMoney(initRate)} to ${NumberUtils.formatMoney(currRate)}.`)
          }

        })
        break;

      case "Product":
        let pIds = _.union(_.keys(initSpend.ProductProperties), _.keys(currSpend.ProductProperties))
        let dctPrd = _.keyBy(<WB_FinishedProductRow[]>await dbContext.findUsingCache(esWB_Finished_Product, pIds), (aRow) => aRow.cif.WB_PROD_ID)
        _.forEach(pIds, (anId: number, key: any) => {
          let aPrd = dctPrd[anId]
          if (!aPrd) {
            return
          }
          let initRate = 0
          let currRate = 0
          if (anId in initSpend.ProductProperties) {
            initRate = initSpend.ProductProperties[anId].Rate_Amt
          }
          if (anId in currSpend.ProductProperties) {
            currRate = currSpend.ProductProperties[anId].Rate_Amt
          }

          if (currRate != initRate) {
            spendChanges.push(`${aPrd.cif.PRODUCT_NAME} (${aPrd.cif.PRODUCT_ID}) rate changed from ${NumberUtils.formatMoney(initRate)} to ${NumberUtils.formatMoney(currRate)}.`)
          }

        })
        break;

    }

    // 3. Included Products
    let newProductGroups = _.difference(currSpend.Included_ProductGroups, initSpend.Included_ProductGroups)
    let removedProductGroups = _.difference(initSpend.Included_ProductGroups, currSpend.Included_ProductGroups)

    let newFinishedProducts = _.difference(currSpend.Included_Finished_Products, initSpend.Included_Finished_Products)
    let removedFinishedProducts = _.difference(initSpend.Included_Finished_Products, currSpend.Included_Finished_Products)

    let newDisplayProducts = _.difference(currSpend.Included_Finished_Products, initSpend.Included_Finished_Products)
    let removedDisplayProducts = _.difference(initSpend.Included_Finished_Products, currSpend.Included_Finished_Products)

    let newProducts = _.union(newFinishedProducts, newDisplayProducts)
    let removedProducts = _.union(removedFinishedProducts, removedDisplayProducts)

    let dctProduct = _.keyBy(<WB_FinishedProductRow[]>await dbContext.findUsingCache(esWB_Finished_Product, _.union(newProducts, removedProducts)), (aRow) => aRow.cif.WB_PROD_ID)
    let prdIdList: string[] = []
    let prdIdNameList: string[] = []
    _.forEach(newProducts, (aNewProductId) => {
      let aPrd = dctProduct[aNewProductId]
      if (aPrd) {
        prdIdList.push(aPrd.cif.PRODUCT_ID)
        prdIdNameList.push(`(${aPrd.cif.PRODUCT_ID}) ${aPrd.cif.PRODUCT_NAME}`)
      }
    })
    if (prdIdList.length) {
      let sNewProducts = ""
      if (prdIdList.length > 5)
        sNewProducts = prdIdList.join(", ")
      else
        sNewProducts = prdIdNameList.join(", ")

      spendChanges.push("New Products: " + sNewProducts)
    }

    prdIdList = []
    prdIdNameList = []
    _.forEach(removedProducts, (aRemovedProductId) => {
      let aPrd = dctProduct[aRemovedProductId]
      if (aPrd) {
        prdIdList.push(aPrd.cif.PRODUCT_ID)
        prdIdNameList.push(`(${aPrd.cif.PRODUCT_ID}) ${aPrd.cif.PRODUCT_NAME}`)
      }
    })
    if (prdIdList.length) {
      let sRemoveProducts = ""
      if (prdIdList.length > 5)
        sRemoveProducts = prdIdList.join(", ")
      else
        sRemoveProducts = prdIdNameList.join(", ")

      spendChanges.push("Removed Products: " + sRemoveProducts)
    }


    // Log Changes to workflow and reset the flag
    let bLogToWorkflow = aSpend.PrimaryWorkflowProcessor.CurrentState.StatusTypeIsPostApproval
    if (spendChanges.length) {
      spnd.cif.OES_SENT_TO_IND = '0'
      if (bLogToWorkflow) {
        spendChanges.unshift(`Off Invoice changes for ${spnd.cif.EVENT_SPEND_ID}:`)
        _.forEach(spendChanges, (aLine) => {
          bo.PrimaryWorkflowProcessor.addStatusHistoryLogMessage(wfLogCode, aLine)
        })
      }
    }


  }


  static async OESSentIndicator_setAggregateIndicators(aBO: TPMEventBO): Promise<void> {

    let dctProducts: { [id: number]: number } = {}
    let dctProductGroups: { [id: number]: number } = {}

    _.forEach(aBO.TPMEventSpends, (aSpend) => {

      if (!aSpend.isActive || (aSpend.TPMEventSpendRow.cif.PAYMENT_METHOD != PaymentMethod_OffInvoice)) {
        return
      }

      _.forEach(aSpend.TPMEventSpendRow.WB_TPM_EventSpendPrdGrpRows, (aRow) => {
        if (!aRow.isActive) {
          return
        }
        if (aRow.cif.OES_SENT_TO_IND == '1') {
          dctProductGroups[aRow.cif.WB_PRDGRP_ID] = aRow.cif.WB_PRDGRP_ID
        }
      })

      _.forEach(aSpend.TPMEventSpendRow.WB_TPM_EventSpendPrdRows, (aRow) => {
        if (!aRow.isActive) {
          return
        }
        if (aRow.cif.OES_SENT_TO_IND == '1') {
          dctProducts[aRow.cif.WB_PROD_ID] = aRow.cif.WB_PROD_ID
        }
      })

    })

    _.forEach(aBO.WB_TPMEvent.WB_TPM_EventProductGroupRows, (aRow) => {
      if (!aRow.isActive) {
        return
      }

      let sOES_Ind = aRow.cif.OES_SENT_TO_IND
      if (aRow.cif.WB_PRDGRP_ID in dctProductGroups) {
        if (sOES_Ind != '1') {
          aRow.cif.OES_SENT_TO_IND = '1'
        }
      } else {
        if (sOES_Ind != '0') {
          aRow.cif.OES_SENT_TO_IND = '0'
        }
      }
    })

    _.forEach(aBO.WB_TPMEvent.WB_TPM_EventProductRows, (aRow) => {
      if (!aRow.isActive) {
        return
      }

      let sOES_Ind = aRow.cif.OES_SENT_TO_IND
      if (aRow.cif.WB_PROD_ID in dctProducts) {
        if (sOES_Ind != '1') {
          aRow.cif.OES_SENT_TO_IND = '1'
        }
      } else {
        if (sOES_Ind != '0') {
          aRow.cif.OES_SENT_TO_IND = '0'
        }
      }
    })

  }


}

